import React from "react";
import "./styles.css";
import { SiGithub } from "react-icons/si";

function Project({
  projectTitle,
  key,
  description,
  tags,
  source,
  demo,
  image,
}) {
  return (
    <div className="project">
      <img src={image} alt="project img" className="project__img" srcset="" />
      <h1 className="project__title">{projectTitle}</h1>
      <p className="description">{description}</p>
      <div className="source__wrapper">
        <a
          href={source}
          target="_blank"
          rel="noreferrer"
          className="project__source"
        >
          <SiGithub fontSize="2rem" />
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          className="project__demo"
          href={demo}
        >
          Demo
        </a>
      </div>
    </div>
  );
}

export default Project;
